import { render, staticRenderFns } from "./UVAS.vue?vue&type=template&id=84ca99b4&scoped=true&lang=pug&"
import script from "./UVAS.vue?vue&type=script&lang=js&"
export * from "./UVAS.vue?vue&type=script&lang=js&"
import style0 from "./UVAS.vue?vue&type=style&index=0&id=84ca99b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ca99b4",
  null
  
)

export default component.exports